// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import plantIcon from "@/assets/icons/aop/plant.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PlantIconProps = Omit<IconProps, "name">;

export function PlantIcon(props: PlantIconProps): React.ReactNode {
  return <Icon name={plantIcon} {...props} />;
}
